import React from 'react';

import { ReactComponent as Spinner } from '../../../../../svgs/spinner.svg';
import styles from './doctorLoadSpinner.module.css';

const DoctorLoadSpinner = () => (
  <div className={styles.container}>
    <Spinner className={styles.spinner} />
    <div style={{ marginTop: '15px' }}>Checking availability, please wait</div>
    <div>(this may take up to a minute)</div>
  </div>
);

export default DoctorLoadSpinner;
